import React, { FC }                    from 'react';
import { ApolloError }                  from 'apollo-client';
import { Divider, Icon, List, Message } from 'semantic-ui-react';
import _                                from 'underscore';
import { print }                        from 'graphql/language/printer'

import { CorvalUIColor, GQLNode }    from '../../../../types';
import { StyledContainer }           from '../../../containers';
import { ENVIRONMENT_IS_PRODUCTION } from '../../../../constants/SystemEnums';
import { HelpAndSupportStatement }   from '../messaging/HelpAndSupportStatement';
import { useCurrentUser }            from '../../../../hooks';

interface Props {
	response: ApolloError,
	query: GQLNode | string,
}

const defaultProps: Props = {
	response: null,
	query:    null,
}

const ErrorMessageFromGraphQL: FC<Props> = ( props ) => {
	
	let { isSystemCorvalAdmin, isSystemAdmin } = useCurrentUser(),
	    hasErrors                              = props?.response?.graphQLErrors ?? false,
	    hasQuery                               = props?.query && _.isObject( props.query ),
	    queryString                            = hasQuery ? print( props.query as any ) : props.query,
	    showSupportContent                     = ( ENVIRONMENT_IS_PRODUCTION && !isSystemAdmin() || !ENVIRONMENT_IS_PRODUCTION && !isSystemCorvalAdmin() ),
	    showGraphDetails                       = ( isSystemCorvalAdmin() && queryString );
	
	return (
		<Message error>
			<Message.Header><Icon name='fork'/> GraphQL Error</Message.Header>
			<Message.Content className={ 'padding-md' }>
				
				{ hasErrors && (
					<List relaxed={ 'very' }>
						
						{ _.pluck( props.response.graphQLErrors, 'message' )
						   .map( ( errorMssg, index ) => (
							   <List.Item key={ index }>{ errorMssg }</List.Item>
						   ) ) }
					
					</List>
				) }
				
				{ ( ( hasErrors || hasQuery ) && showSupportContent || showGraphDetails ) && <Divider/> }
				
				{ showSupportContent && (
					<p>
						An error has occured requesting data!
						{ ' ' }If the error persists, use the { ENVIRONMENT_IS_PRODUCTION ? 'feedback tab' : 'report issue feature' } to report this issue.
						{ ' ' }<HelpAndSupportStatement contactName={ 'Corval Technical Support' }/>
					</p>
				) }
				
				{ hasQuery && showGraphDetails && (
					<StyledContainer bgColor={ CorvalUIColor.LT_SCREEN_25 } rounded>
						<code>
							<pre style={ { whiteSpace: 'pre-wrap' } }>{ queryString }</pre>
						</code>
					</StyledContainer>
				) }
			
			</Message.Content>
		</Message>
	);
};

ErrorMessageFromGraphQL.defaultProps = defaultProps;

export { ErrorMessageFromGraphQL }
